import isEqual from 'lodash/isEqual'

import { createSelector } from '@app/utils/createSelector'
import { invariant } from '@app/utils/invariant'
import { isRegionAvailable } from '@app/utils/regions'

import { regionsListSelector, regionsMapSelector } from '@app/store/slices/regions'

export const regionsSelector = createSelector([regionsListSelector, regionsMapSelector], (list, models) =>
  list.map(id => models[id] ?? invariant("Region model missing for id '" + id + "'"))
)

export const defaultRegionSelector = createSelector([regionsSelector], regions => regions.find(c => c.attributes.slug === 'msk')!)

export const availableRegionsSelector = createSelector([regionsSelector], regions => regions.filter(city => city.attributes.available))

export const availableRegionsForLandingSelector = availableRegionsSelector

export const availableRegionsForParentSelector = availableRegionsSelector

export const availableRegionsForSitterSelector = availableRegionsSelector

export const availableRegionsForSitterOfflineSearchSelector = createSelector([regionsSelector], regions =>
  regions.filter(region => region.attributes.available && region.attributes.type === 'city')
)

export const schoolRegionsSelector = createSelector([regionsSelector], regions =>
  regions.filter(region => !!region.attributes.school || !!region.attributes.online_school)
)

export const availableRegionsSlugsSelector = createSelector([availableRegionsForLandingSelector], regions =>
  regions.filter(r => isRegionAvailable(r.attributes)).map(c => c.attributes.slug)
)
export const routingSlugsSelector = createSelector([availableRegionsSlugsSelector], regions => regions.filter(r => r !== 'msk'), {
  resultEqual: isEqual,
})
